import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import { injectConfig, configShape } from '@client/hoc/config';

import { Dialog, Size } from '@pegasus/ui-components/components/dialog';
import { Button, ButtonColor, ButtonType } from '@pegasus/ui-components/components/button';

import {
    getIsPermissionDialogOpen,
    getCampaignToSubscribe
} from '@client/redux/modules/pushNotification/selectors';
import { getFirstName } from '@client/redux/modules/customer/selectors';
import { getHasAccessibleOrange } from '@client/redux/modules/abtesting/accessibleOrange/selectors';

import {
    resetCampaignToSubscribe,
    registerForNotification,
    hidePermissionDialog,
    sendPushNotification
} from '@client/redux/modules/pushNotification/actions';

import Translate from '@client/components/shared/translation/Translate';
import { NotificationPermissionIcon } from '@client/components/shared/SvgIcons';
import { track } from '@client/helpers/tracking';

import styles from './styles.scss';

export class NotificationPermissionDialog extends Component {
    static propTypes = {
        isShown: PropTypes.bool,
        firstName: PropTypes.string.isRequired,
        campaignToSubscribe: PropTypes.string,
        accessibleOrange: PropTypes.bool,
        sendPushNotification: PropTypes.func.isRequired,
        registerForNotification: PropTypes.func.isRequired,
        hidePermissionDialog: PropTypes.func.isRequired,
        config: configShape,
        intl: PropTypes.object
    };

    render() {
        const {
            isShown,
            firstName,
            accessibleOrange
        } = this.props;

        return (
            <Dialog isShown={isShown} size={Size.M} closeDialog={this.closeDialog} >
                <div styleName="wrapper">
                    <div styleName="icon-container">
                        <NotificationPermissionIcon styleName="notificaiton-icon" />
                    </div>
                    <div styleName="text-container">
                        <div styleName="title"><Translate message="title" params={{ firstName }} /></div>
                        <div styleName="text"><Translate message="text" /></div>
                    </div>
                    <div styleName="buttons-container">
                        <div styleName="button-wrapper">
                            <Button
                                color={accessibleOrange ? ButtonColor.primary : ButtonColor.brand}
                                buttonType={ButtonType.primary}
                                fullWidth
                                onClick={this.showNativePermissionDialog}
                            >
                                <Translate message="ctaButton" />
                            </Button>
                        </div>
                        <div styleName="button-wrapper">
                            <Button
                                color={ButtonColor.dark}
                                buttonType={ButtonType.primary}
                                fullWidth
                                onClick={this.cancelDialog}
                            >
                                <Translate message="cancelButton" />
                            </Button>
                        </div>
                    </div>
                </div>
            </Dialog>
        );
    }

    closeDialog = () => {
        const { campaignToSubscribe } = this.props;
        track('notification_push_close', { productCampaign: campaignToSubscribe });
        this.props.hidePermissionDialog();
    }

    cancelDialog = () => {
        const { campaignToSubscribe } = this.props;
        track('notification_push_cancel', { productCampaign: campaignToSubscribe });
        this.props.hidePermissionDialog();
    }

    showNativePermissionDialog = async () => {
        const { campaignToSubscribe } = this.props;
        const { config, intl } = this.props;

        track('notification_push_optIn', { productCampaign: campaignToSubscribe });
        const { appdomainid } = config;

        this.props.hidePermissionDialog();

        this.props.registerForNotification({
            campaignToSubscribe,
            appdomainid,
            errorMessage: intl.formatMessage({ id: 'registrationError' }),
            successMessage: intl.formatMessage({ id: 'registrationSuccess' })
        });
    }
}
const mapStateToProps = state => ({
    isShown: getIsPermissionDialogOpen(state),
    campaignToSubscribe: getCampaignToSubscribe(state),
    firstName: getFirstName(state),
    accessibleOrange: getHasAccessibleOrange(state)
});

export default compose(
    injectConfig,
    connect(mapStateToProps, {
        hidePermissionDialog,
        sendPushNotification,
        resetCampaignToSubscribe,
        registerForNotification,
    }),
    injectIntl,
    CSSModules(styles)
)(NotificationPermissionDialog);
